const faqDetail = document.querySelector(".Faq.Detail");
const faqOverview = document.querySelector(".Faq.Overview");
if (faqDetail || faqOverview) {
	if (faqDetail) {
		Array.from(faqDetail.querySelectorAll(".Faq.Item")).forEach(item => {
			item.addEventListener("click", () => {
				!item.classList.contains("open") ? item.classList.add("open") : item.classList.remove("open");
			});
		});
	}
	if (faqOverview) {
		Array.from(faqOverview.querySelectorAll(".Faq.Item")).forEach(item => {
			item.addEventListener("click", () => {
				!item.classList.contains("open") ? item.classList.add("open") : item.classList.remove("open");
			});
		});
	}


	// Use this if using Ajax filtering -- Search and Filter Pro
	// (function ( $ ) {
	// 	"use strict";
	//
	// 	$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
	// 		if (faqDetail) {
	// 			Array.from(faqDetail.querySelectorAll(".Faq.Item")).forEach(item => {
	// 				item.addEventListener("click", () => {
	// 					!item.classList.contains("open") ? item.classList.add("open") : item.classList.remove("open");
	// 				});
	// 			});
	// 		}
	// 		if (faqOverview) {
	// 			Array.from(faqOverview.querySelectorAll(".Faq.Item")).forEach(item => {
	// 				item.addEventListener("click", () => {
	// 					!item.classList.contains("open") ? item.classList.add("open") : item.classList.remove("open");
	// 				});
	// 			});
	// 		}
	// 	});
	// }(jQuery));
}